import { TextField as MuiTextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import { isValidNumberInput } from '../../utils/utils';

const SpecialArrayField = ({ field }: { field: any }) => {
  const { getFormDataItem, handleSpecialArrayFieldChange } = useFormContext();
  const formData = useFormData();

  const handleItemChange = (e: any, item: any, index: number) => {
    const value = e.target.value;

    if (item.type === 'number') {
      if (isValidNumberInput(value)) {
        handleSpecialArrayFieldChange(e, field, index);
      }
    } else {
      handleSpecialArrayFieldChange(e, field, index);
    }
  };

  return (
    <Grid size={field.size || 12} key={field.name}>
      <Typography color="text.primary" variant={field.font_size || 'h6'} sx={{ mb: 1 }}>
        {field.label}
      </Typography>
      <Grid container spacing={2} size={12} key={field.name + 'x'}>
        {field.items.map((item: any, index: number) => (
          <Grid size={item.size || 12} key={item.name}>
            <MuiTextField
              label={item.label}
              fullWidth
              required={item.required || false}
              disabled={field.hasOwnProperty('disabled') ? getFormDataItem(formData, field.disabled) : false}
              type="text"
              name={item.name}
              value={getFormDataItem(formData, field.name)[index] ?? ''}
              onChange={(e) => handleItemChange(e, item, index)}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default SpecialArrayField;
